<template>
  <div>
    <!-- AppHeaderNew -->
    <AppHeaderNew />

    <section class="pages-banner">
      <div class="container text-center banner-box h-100">
        <h1>Customer Care</h1>
      </div>
    </section>

    <div class="container inner-page-box faq-page-box">
      <div class="container breadcrumb-box">
        <p>
          <router-link :to="{name: 'home'}">Home</router-link>> Customer Care
        </p>
      </div>
      <h3>Customer Care</h3>
      <div class="customer-care-page-box">
        <div class="row">
          <div class="col-xl-8 col-lg-12">
            <div class="row top-boxes">
              <div class="col-lg-6">
                <div class="contact-box">
                  <h5>Customer Support</h5>
                  <p>
                    Toll Free No.:
                    <span>+65 3138 4611</span>
                  </p>
                  <p>
                    Phone:
                    <span>+977 1 55885566</span>
                  </p>
                  <p>
                    Email:
                    <span>support@amejpay.com</span>
                  </p>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="contact-box right-contact-box">
                  <h5>FAQs</h5>
                  <p>Having any issues confusions, or got stuck?</p>
                  <p>
                    Have a look at
                    <router-link :to="{name: 'faqNew'}">FAQs</router-link>.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 d-none d-xl-block customer-care-photo">
            <img src="../../assets/customer/care.png" alt />
          </div>
        </div>
      </div>
    </div>

    <!-- FooterNew -->
    <AppFooterNew />
  </div>
</template>

<script type="text/javascript">
import AppHeaderNew from "../reuseable_components/HeaderNew";
import AppFooterNew from "../reuseable_components/FooterNew";

export default {
  name: "customerCare",
  components: {
    AppHeaderNew,
    AppFooterNew,
  },
  data() {
    return {
      //
    };
  },
};
</script>